import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TealiumUtagService } from '../../../../tealium/utag.service';
import { Suggestions } from '../../model/suggestions.model';
import { EventService } from '../../controller/event.service';


@Component({
  selector: "app-event-suggestions",
  templateUrl: "./event-suggestions.component.html",
  styleUrls: [],
})
export class EventSuggestionsComponent implements OnInit {
  @Input() suggestions: Suggestions;
  @Input() buSlug: string;
  @Input() spotlightSlug: string;
  constructor(
    private route: ActivatedRoute,
    private tealium: TealiumUtagService,
    public EventController: EventService,
  )
  { }

  ngOnInit() {}

  public changeLink(track_zone, track_nom, track_cible = "", slug)
  {
    this.sendLink(track_zone, track_nom, track_cible);
    this.EventController.changeStep(1);
    this.EventController.getEventInformations(slug).then(()=> {
      let typeEvent = this.EventController.event.type == "physical"
          ? "en_physique"
          : "en_ligne";
      this.tealium.view(
        "page_atelier",
        document.title,
        this.EventController.event.buSlug,
        typeEvent,
        this.EventController.event.trackingId
      );
    });
  }
  /**
   * Envoie les infos utag
   * @param track_zone | string : Nom du tracking
   * @param track_nom | string : Nom du tracking
   * @param track_cible | string : Slug du tracking
   */
  public sendLink(track_zone, track_nom, track_cible = "") {
    console.log( "page_atelier_" +
    this.route.snapshot.paramMap.get("event") +
    "_" +
    track_zone)
    this.tealium.link({
      track_zone:
        "page_atelier_" +
        this.route.snapshot.paramMap.get("event") +
        "_" +
        track_zone,
      track_nom: track_nom,
      track_cible:
        window.location.href.split("/")[0] +
        "/" +
        window.location.href.split("/")[2] +
        "/" +
        track_cible,
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/register-event/view/event-suggestions/event-suggestions.component.ts